module.exports = __webpack_public_path__ + "img/xiaoxueshuxue.75bd45ce.png";